module.exports = __webpack_public_path__ + "static/pic03-e61f98c8f11a7892afbad4f9949a346d.jpg";